import React, { useState } from 'react'
import styled from '@emotion/styled'
import { Modal } from 'antd'
import { HiX } from 'react-icons/hi'
import ExpandIcon from 'packages/@slerp/assets/expand.svg'

interface ExpandableImageProps {
  src: string
  alt: string
}

// antd Modal supplies the mask, mask-click/Escape close and scroll lock;
// modalRender swaps its white content box for the bare image.
const ExpandableImage = ({ src, alt }: ExpandableImageProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const close = () => setIsOpen(false)

  return (
    <>
      <Trigger
        type='button'
        aria-label='Expand image'
        onClick={() => setIsOpen(true)}
      >
        <ThumbnailImage src={src} alt={alt} />
        <HoverOverlay>
          <img src={ExpandIcon} alt='' />
        </HoverOverlay>
      </Trigger>

      <Modal
        open={isOpen}
        onCancel={close}
        footer={null}
        centered
        width='90vw'
        modalRender={() => (
          <ExpandedFrame>
            <CloseButton type='button' aria-label='Close' onClick={close}>
              <HiX />
            </CloseButton>
            <ExpandedImage src={src} alt={alt} />
          </ExpandedFrame>
        )}
      />
    </>
  )
}

const Trigger = styled.button`
  position: relative;
  display: block;
  width: 100%;
  padding: 0;
  border: none;
  border-radius: 6px;
  background: none;
  overflow: hidden;
  cursor: zoom-in;
`

const ThumbnailImage = styled.img`
  display: block;
  width: 100%;
  height: auto;
`

const HoverOverlay = styled.span`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.1);
  opacity: 0;
  transition: opacity 0.2s;

  img {
    width: 32px;
    height: 32px;
  }

  button:hover > &,
  button:focus-visible > & {
    opacity: 1;
  }
`

// antd sets pointer-events: none on .ant-modal and re-enables it only on its
// own content box, which modalRender replaces.
const ExpandedFrame = styled.div`
  position: relative;
  pointer-events: auto;
`

const ExpandedImage = styled.img`
  display: block;
  width: 100%;
  max-height: 85vh;
  object-fit: contain;
  border-radius: 6px;
`

const CloseButton = styled.button`
  position: absolute;
  top: -44px;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.9);
  color: #4a4a68;
  font-size: 20px;
  cursor: pointer;

  &:hover {
    background-color: #ffffff;
  }
`

export default ExpandableImage
